import { Outlet } from "react-router-dom";
import { useThemeSync } from "@hooks/useThemeSync";
import { useAppSelector } from "@app/hooks";
import { LeftNav } from "./LeftNav";

/**
 * App shell — the Oxbo P3 rail layout (kit `.app.rail` = a 56px icon nav + a
 * full-height main). No top header; the left nav is the only chrome (field /
 * tablet ergonomics). Applies the active theme to the DOM and wraps content in
 * the lineage scope (only tinted when the admin overlay is on).
 */
export function AppShell() {
  useThemeSync();
  const collapsed = useAppSelector((s) => s.prefs.navCollapsed);
  const lineageOn = useAppSelector((s) => s.prefs.lineageOverlay);

  return (
    <div className={`app${collapsed ? " rail" : ""}${lineageOn ? " lineage-on" : ""}`}>
      <LeftNav />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
